import { useProductViewCommon } from '@/hooks/useProductViewCommon';
import { useProductViewDataSource } from '@/hooks/useProductViewDataSource';
import { ProductViewHook } from '@/types/product-view-model';
import { ProductViewModes } from '@/utils/productStateUtils';

/**
 * Hook used by the product edit route.
 *
 * The route only chooses the view mode; shared UI behavior remains in
 * `useProductViewCommon`, while endpoint behavior is provided by the data source.
 */
export function useProductEdit(): ProductViewHook {
  const dataSource = useProductViewDataSource(ProductViewModes.Edit);
  return useProductViewCommon(dataSource);
}
